module.exports = __webpack_public_path__ + "static/media/TPL.9968781d.svg";